export default __webpack_public_path__ + "static/media/notification.6e3895fb.mp3";